import React from 'react';

import DebtCalculatorController from '../../../apps/debtCalculator/debtCalculatorController/DebtCalculatorController';

const DebtCalculatorBlock = ({ data }) => {
  const { heading, subheading } = data;
  return <DebtCalculatorController heading={heading} subheading={subheading} />;
};

export default DebtCalculatorBlock;
